module.exports = __webpack_public_path__ + "static/media/bf.fe12d73a.svg";